module.exports = __webpack_public_path__ + "BHALogo-66d6f30698c0a20e4d50f98b788a486b.svg";